import type { FC } from 'react';
import clsx from 'clsx';

import { comparisonIconColorClasses, type ComparisonStatus, sidebarBlockIconClasses } from './classes';

interface NavBlockIconProps {
  isActive?: boolean;
  isExcluded?: boolean;
  variant?: ComparisonStatus;
  className?: string;
}

export const NavBlockIcon: FC<NavBlockIconProps> = ({
  isActive = false,
  isExcluded = false,
  variant = 'default',
  className,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      sidebarBlockIconClasses(),
      isActive ? 'text-primary-600' : comparisonIconColorClasses[variant],
      isExcluded && 'opacity-25',
      className,
    )}
  >
    <rect width="16" height="16" rx="4" fill="currentColor" />
    <path
      d="M7.99935 4.5H12.666M7.99935 8H12.666M3.04102 4.5H5.37435M7.99935 11.5H12.666"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface NavAttachmentIconProps {
  variant?: ComparisonStatus;
  className?: string;
}

export const NavAttachmentIcon: FC<NavAttachmentIconProps> = ({ variant = 'default', className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(sidebarBlockIconClasses(), comparisonIconColorClasses[variant], className)}
  >
    <rect width="16" height="16" rx="4" fill="currentColor" />
    <path
      d="M5.08333 6.15122L8.92504 9.99293C9.38065 10.4485 10.1193 10.4485 10.575 9.99293C11.0306 9.53731 11.0306 8.79862 10.575 8.34301L6.73325 4.60139C5.82203 3.69016 4.34464 3.69016 3.43342 4.60139C2.52219 5.51261 2.52219 6.99 3.43342 7.90122L7.27513 11.6428C8.64196 13.0097 10.858 13.0097 12.2249 11.6428C13.5917 10.276 13.5917 8.05993 12.2249 6.6931L8.58333 3.04297"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
